/**
 * PresencePanel — 편집 화면 상단 참여자 avatar 스택
 */
import { seedToColor } from './color_utils'

export class PresencePanel {
  constructor(options) {
    this.container = options?.container || options
    this.participants = new Map()
    this.myConnectionUid = null

    this.panelEl = document.createElement('div')
    this.panelEl.className = 'collab-presence-panel'
    this.panelEl.style.cssText = 'display:flex;align-items:center;gap:4px;'

    this.statusDot = document.createElement('div')
    this.statusDot.style.cssText = 'width:8px;height:8px;border-radius:50%;background:#ccc;margin-right:8px;flex-shrink:0;'
    this.panelEl.appendChild(this.statusDot)

    this.avatarsEl = document.createElement('div')
    this.avatarsEl.style.cssText = 'display:flex;align-items:center;'
    this.panelEl.appendChild(this.avatarsEl)

    this.container.appendChild(this.panelEl)
  }

  setSelf({ connectionUid, name, image }) {
    this._selfKey = connectionUid
    this.myConnectionUid = connectionUid
    if (this.participants.has(connectionUid)) return

    const color = seedToColor(name || connectionUid)
    const el = this._createAvatarEl({ name, image, color, isMe: true })
    this.avatarsEl.prepend(el)
    this.participants.set(connectionUid, { name, image, color, el })
  }

  updateMyConnectionUid(realUid) {
    if (!realUid) return
    const oldKey = this._selfKey
    this.myConnectionUid = realUid
    if (oldKey && oldKey !== realUid && this.participants.has(oldKey)) {
      const entry = this.participants.get(oldKey)
      this.participants.delete(oldKey)
      this.participants.set(realUid, entry)
      this._selfKey = realUid
    }
  }

  setStatus(status) {
    const colors = { connected: '#22c55e', connecting: '#f59e0b', disconnected: '#ef4444' }
    this.statusDot.style.backgroundColor = colors[status] || '#ccc'
  }

  handlePresenceEvent(data) {
    const uid = data.connection_uid

    if (data.action === 'join') {
      // 서버에서 is_self: true로 표시한 자기 자신의 join
      if (data.is_self) {
        this.myConnectionUid = uid

        // broadcast가 먼저 도착해서 자기가 일반 참여자로 추가된 경우 제거 후 재추가
        if (this.participants.has(uid)) {
          const old = this.participants.get(uid)
          old.el.remove()
          this.participants.delete(uid)
        }

        const color = seedToColor(uid)
        const el = this._createAvatarEl({ name: data.user_name, image: data.user_image, color, isMe: true })
        this.avatarsEl.prepend(el)
        this.participants.set(uid, { name: data.user_name, color, el })
        return
      }

      // 자기 자신의 broadcast 중복은 무시
      if (uid && uid === this.myConnectionUid) return

      const key = uid || data.editor_id
      if (!key || this.participants.has(key)) return
      const color = seedToColor(key)
      const el = this._createAvatarEl({ name: data.user_name, image: data.user_image, color })
      this.avatarsEl.appendChild(el)
      this.participants.set(key, { name: data.user_name, image: data.user_image, color, el })
    } else if (data.action === 'leave') {
      if (uid && uid === this.myConnectionUid) return
      const key = uid || data.editor_id
      const p = this.participants.get(key)
      if (p) { p.el.remove(); this.participants.delete(key) }
    }
  }

  destroy() {
    this.panelEl.remove()
    this.participants.clear()
  }

  _createAvatarEl({ name, image, color, isMe = false }) {
    const wrapper = document.createElement('div')
    wrapper.style.cssText = 'position:relative;margin-left:-6px;flex-shrink:0;'

    const el = document.createElement('div')
    el.style.cssText = `
      width:28px;height:28px;border-radius:50%;
      border:2px solid ${color || '#6b7280'};
      display:flex;align-items:center;justify-content:center;
      font-size:12px;font-weight:600;color:white;
      background:${color || '#6b7280'};overflow:hidden;cursor:default;
    `

    if (image) {
      const img = document.createElement('img')
      img.src = image
      img.alt = name || ''
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;'
      img.onerror = () => { img.remove(); el.textContent = (name || '?')[0].toUpperCase() }
      el.appendChild(img)
    } else {
      el.textContent = (name || '?')[0].toUpperCase()
    }

    if (isMe) {
      const badge = document.createElement('div')
      badge.textContent = '나'
      badge.style.cssText = `
        position:absolute;bottom:-2px;right:-2px;
        background:#000;color:white;font-size:8px;line-height:12px;
        padding:0 3px;border-radius:6px;border:1px solid white;
        pointer-events:none;z-index:1;
      `
      wrapper.appendChild(badge)
    }

    const tooltip = document.createElement('div')
    tooltip.textContent = isMe ? `${name || 'Anonymous'} (나)` : (name || 'Anonymous')
    tooltip.style.cssText = `
      position:absolute;bottom:calc(100% + 6px);left:50%;transform:translateX(-50%);
      padding:4px 8px;background:#1f2937;color:white;font-size:11px;line-height:16px;
      border-radius:4px;white-space:nowrap;pointer-events:none;opacity:0;
      transition:opacity 0.15s;z-index:50;
    `
    wrapper.appendChild(el)
    wrapper.appendChild(tooltip)
    wrapper.addEventListener('mouseenter', () => { tooltip.style.opacity = '1' })
    wrapper.addEventListener('mouseleave', () => { tooltip.style.opacity = '0' })

    return wrapper
  }

}
